module.exports = __webpack_public_path__ + "img/collaborate.8162fa46.svg";